import { useState, useEffect } from "react";
import { db } from "../lib/firebase";
import { collection, query, onSnapshot, orderBy } from "firebase/firestore";

export const useMonthlyImpact = () => {
    const [allData, setAllData] = useState([]);
    const [availableYears, setAvailableYears] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const q = query(collection(db, "consumos"), orderBy("anio", "desc"), orderBy("mes", "asc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {
            const data = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));

            setAllData(data);

            // Extract unique years
            const years = [...new Set(data.map(item => item.anio))].sort((a, b) => b - a);
            setAvailableYears(years);
            setLoading(false);
        }, (error) => {
            console.error("Error fetching monthly impact data:", error);
            setLoading(false);
        });

        return () => unsubscribe();
    }, []);

    const getDataByYear = (year) => {
        // Find data for the specific year
        const yearData = allData.filter(item => item.anio === year);

        // Ensure all 12 months are represented for the chart, even if 0
        const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];

        return months.map((monthName, index) => {
            const monthIndex = index + 1;
            // Support both numeric month or month name in DB
            const match = yearData.find(d => d.mes === monthIndex || d.mes === monthName);

            return {
                month: monthName,
                energy: match?.produccion || 0,
                savings: match?.ahorro || 0,
                // CO2 will be calculated in the component using the config factor
            };
        });
    };

    return {
        availableYears,
        getDataByYear,
        loading,
        hasData: allData.length > 0
    };
};
